import { QueueListIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import HeaderActions from "../../../components/lines-managements/header/HeaderActions";
import Filters from "../../../components/lines-managements/header/HeaderFilters";
import BulkLineTripPickerModal from "../../../components/lines-managements/trips/BulkLineTripPickerModal";
import Trips from "../../../components/lines-managements/trips/Trips";
import Button from "../../../components/ui/Button";
import SuperAdmin from "../../../components/users/permissions/SuperAdmin";
import useCan from "../../../components/users/permissions/useCan";
import useSuperAdmin from "../../../components/users/permissions/useSuperAdmin";

const TripsPage: React.FC = () => {
  const can = useCan("route.trip.create");
  const isSuperAdmin = useSuperAdmin();
  const [isBulkPickerOpen, setIsBulkPickerOpen] = useState(false);

  return (
    <>
      <div className="mb-4 flex flex-row gap-3 justify-between items-center">
        <div className="flex gap-3 items-center">
          {can && (
            <HeaderActions
              to="create"
              state={["Menaxhimi i linjave", "Oraret", "Shto orar të ri"]}
            >
              Shto orar të ri
            </HeaderActions>
          )}
          <SuperAdmin>
            <Button
              onClick={() => setIsBulkPickerOpen(true)}
              btnType="custom"
              padding="sm:px-4 px-3 sm:py-[9px] py-[10px]"
              className="flex items-center gap-2 border border-primary
               text-primary hover:bg-primary hover:text-white transition-colors"
            >
              <QueueListIcon className="w-4 h-4" />
              <span className="hidden sm:inline">Përditëso shumë orare</span>
            </Button>
          </SuperAdmin>
        </div>
        <Filters />
      </div>
      <Trips />
      {isSuperAdmin && (
        <BulkLineTripPickerModal
          isOpen={isBulkPickerOpen}
          onClose={() => setIsBulkPickerOpen(false)}
        />
      )}
    </>
  );
};

export default TripsPage;
